import { ApiConfig, handleResponse } from './config';
import { ModuleProgress } from '../../types/module';
import apiClient from './client';

export class ProgressService {
  constructor(private config: ApiConfig) {}

  // Get current auth headers with fresh token
  private getAuthHeaders(): Record<string, string> {
    const headers = { ...this.config.headers };
    
    // Try to get fresh token from auth store
    if (typeof window !== 'undefined') {
      try {
        const authStorage = JSON.parse(localStorage.getItem('auth-storage') || '{}');
        const token = authStorage.state?.token;
        if (token && token !== 'null' && token !== 'undefined' && token !== '') {
          headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        // Keep existing headers if we can't get fresh token
      }
    }
    
    return headers;
  }

  async getProgress(): Promise<ModuleProgress[]> {
    try {
      const response = await apiClient.get('/progress');
      const data = Array.isArray(response.data) ? response.data : [];
      return data.map((p: any) => {
        const item = { ...p, id: p.id ?? p._id };
        if (item.contentProgress && Array.isArray(item.contentProgress)) {
          item.contentProgress = Object.fromEntries(item.contentProgress);
        }
        return item;
      });
    } catch (error: any) {
      // apiClient will attempt token refresh on 401; if it still fails (logout), return empty
      if (error.response?.status === 401) {
        return [];
      }
      return [];
    }
  }

  async getUserProgress(userId: string): Promise<ModuleProgress[]> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/progress/${userId}`, {
      headers
    });

    return handleResponse(response);
  }

  async updateProgress(
    userId: string,
    moduleId: string,
    contentId: string,
    update: {
      completed: boolean;
      lastAccessed?: Date;
      quizScore?: number;
      exerciseSubmission?: string;
    }
  ): Promise<ModuleProgress> {
    // Use apiClient so the 401-refresh interceptor fires automatically
    const response = await apiClient.put(`/progress/${userId}/${moduleId}`, {
      contentId,
      ...update
    });

    const result = { ...response.data, id: response.data.id ?? response.data._id };
    if (result.contentProgress && Array.isArray(result.contentProgress)) {
      result.contentProgress = Object.fromEntries(result.contentProgress);
    }
    return result;
  }

  async getModuleProgress(userId: string, moduleId: string): Promise<ModuleProgress> {
    const headers = this.getAuthHeaders();
    const response = await fetch(`${this.config.baseUrl}/progress/${userId}/${moduleId}`, {
      headers
    });

    return handleResponse(response);
  }
}